/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-shadow */
import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "../../../services/actions"

import Icon from "../Icon"

// Selectors
import { getSorting } from "../../../services/selectors/visionSelectors"

// Utils
import { dashToTitleCase } from "../utils"

const HeaderRow = props => {
  const { rowSpacing, sorting, keys, actions } = props
  const divClasses =
    "scores-th d-flex justify-content-center font-weight-bold pr-2 text-truncate"
  // TODO: address accessibility for header tabs
  return (
    <div className="scores-hr d-flex">
      {keys.map((key, i) => (
        <div
          key={`th-${key}`}
          style={rowSpacing}
          className={i === 0 ? `${divClasses}` : `${divClasses} pl-2`}
          onClick={() => {
            return actions.sortColumn(key, sorting.order)
          }}
        >
          <p
            className={`text-truncate ${
              key === "name" ? "text-align-left" : ""
            }`}
          >
            <span>{dashToTitleCase(key)}</span>
            <Icon name="sortArrows" keyName={key} sorting={sorting} />
          </p>
        </div>
      ))}
    </div>
  )
}

HeaderRow.propTypes = {
  rowSpacing: PropTypes.shape({
    flex: PropTypes.string,
    minWidth: PropTypes.string
  }).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  sorting: PropTypes.shape({
    columnName: PropTypes.string,
    order: PropTypes.string
  }).isRequired,
  actions: PropTypes.shape({
    sortColumn: PropTypes.func
  }).isRequired
}

const mapStateToProps = state => ({
  sorting: getSorting(state)
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(actions, dispatch)
  }
}

// export HeaderRow
export default connect(mapStateToProps, mapDispatchToProps)(HeaderRow)
